import Vue from 'vue'

const TaskAssign = {
  namespaced: true,
  state: {
    metadata: {}
  },
  getters: {},
  mutations: {
    UPDATE_META_DATA (state, data) {
      if (typeof data === 'object') {
        Object.keys(data).forEach((item) => {
          Vue.set(state.metadata, item, data[item])
        })
      }
    }
  },
  actions: {
    FETCH_META_DATA ({commit}, params) {
      commit('UPDATE_META_DATA', params)
    }
  }
}

export default TaskAssign
